<template>
  <div>
    <div class="col-4 submit btn-container">
      <button class="btn-cancel" @click="navigateToHome" :disabled="submitted"><span class="icon-cross" aria-label="close"></span></button>
      <button :class="{disabled: !formIsValid}" class="btn btn-primary" @click.stop="onSubmit()" :disabled="submitted" aria-label="done">Create</button>
    </div>
    <div>
      <label class="label" for="clubTitle">Club Title</label>
      <input id="clubTitle" v-model="title">
    </div>

    <hr>

    <div>
      <div>
        <label class="label" for="clubDescription">Club Description</label>
        <input id="clubDescription" v-model="description">
      </div>

      <div>
        <label class="label" for="usefulLinks">UsefulLinks</label>
        <div id="usefulLinks">
          <input v-model="url" placeholder="URL">
          <input v-model="twitter_url" placeholder="Twitter Url">
          <input v-model="facebook_url" placeholder="Facebook URL">
        </div>
      </div>

      <div>
        <label class="label" for="clubPhoneNumber">Phone</label>
        <input id="clubPhoneNumber" v-model="phone_number">
      </div>

      <div>
        <label class="label" for="clubAddress">Address</label>
        <input id="clubAddress" v-model="address">
      </div>

      <div>
        <label class="label" for="clubPrimaryContactName">Primary Contact Name</label>
        <input id="clubPrimaryContactName" v-model="primary_contact_name">
      </div>

      <div>
        <label class="label" for="clubPrimaryContactEmail">Primary Contact Email</label>
        <input id="clubPrimaryContactEmail" v-model="primary_contact_email">
      </div>

      <div>
        <label class="label" for="clubPrimaryContactPhone">Primary Contact Phone</label>
        <input id="clubPrimaryContactPhone" v-model="primary_contact_phone_number">
      </div>
    </div>

    <hr>

    <div>
      <div>
        <label class="label" for="clubOwningLibrary">Folder</label>
        <select id="clubOwningLibrary" v-model="selectedFolder">
          <option v-for="learningSpace in learningSpaces" v-bind:value="learningSpace">
            {{ learningSpace.displayName }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'club-create',
    props: [],
    data: () => {
      return {
        submitted: false,
        selectedFolder: {},
        errors: [],
        userId: {},
        uuid: undefined,
        title: '',
        description: '',
        owningLibraryId: {},
        phone_number: '',
        address: '',
        primary_contact_name: '',
        primary_contact_email: '',
        primary_contact_phone_number: '',
        ownerName: '',
        url: '',
        twitter_url: '',
        facebook_url: ''
      }
    },
    mounted () {
      this.loadDataForCreateClub()
    },
    methods: {
      ...mapActions([
        'loadLibrariesForUser',
        'storeClub'
      ]),
      clubDataIsValid () {
        let isValid = true
        if (!this.title) {
          isValid = false
          this.errors.push('Error: Club title cannot be blank or null')
        }
        if (!this.selectedFolder || !this.selectedFolder.uuid) {
          isValid = false
          this.errors.push('Error: Please select one folder in which to store this entity')
        }
        return isValid
      },
      onSubmit () {
        if (!this.clubDataIsValid()) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: this.errors.join('\n')
          })
          this.errors = []
          return
        }
        this.submitted = true
        const clubData = {
          title: this.title,
          description: this.description,
          owningLibraryId: this.selectedFolder.uuid,
          phone_number: this.phone_number,
          address: this.address,
          primary_contact_name: this.primary_contact_name,
          primary_contact_email: this.primary_contact_email,
          primary_contact_phone_number: this.primary_contact_phone_number,
          ownerName: this.ownerName,
          url: this.url,
          twitter_url: this.twitter_url,
          facebook_url: this.facebook_url
        }
        this.storeClub(clubData).then(response => {
          console.log('the response: ' + response)
          this.uuid = response.uuid
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Club "' + this.title + '" created successfully.'
          })
          return this.$router.push({ name: 'clubDetail', params: { uuid: this.uuid } })
        })
      },
      navigateToHome () {
        return this.$router.go(-1)
      },
      loadDataForCreateClub () {
        this.userId = localStorage.getItem('userid')
        this.loadLibrariesForUser(this.userId)
      }
    },
    computed: {
      ...mapState({
        'learningSpaces': state => state.assessment.learningSpaces
      }),
      formIsValid: function () {
        return this.title && this.selectedFolder.uuid
      }
    }
  }
</script>

<style scoped>
  .label {
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/app/club/components/ClubCreate.vue